import styled from 'styled-components'

const ErrorUi = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 5px;
`

export default ErrorUi
